// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mRv9","select":"styles_select__1IwB2"};